module.exports = __webpack_public_path__ + "static/media/anchor_rank_2.9c1ea770.png";